import React, { useState, useEffect, useRef} from 'react';
import SizeSelectorItem from '../size-selector/SizeSelectorItem.jsx';
import { withTranslation } from 'react-i18next';

const WidthSelector = ({sku, variantSize,  groupProductWidth, fontStyle, variantWidth, setVariantWidth, t}) => {
    const [widthList, setWidthList] = useState(null);
    const scrollRef = useRef();

     useEffect(() => {
        if(groupProductWidth) {
            const widthArray = Object.keys(groupProductWidth);
            setWidthList(widthArray);
            setVariantWidth(widthArray[0])
        }

    }, [sku, variantSize])


    const handleOnClick = (width) => {
        setVariantWidth(width)
    }

    return (

        <div id="size-selector-column" className="flex-center" style={{ ...fontStyle }}>
             <div className="size-text">{t('selectAWidth')}</div>
             <div id="size-selector-items" className="flex-center" ref={scrollRef} >
                {widthList && widthList.map((width, index) => (
                    <SizeSelectorItem
                        key={index}
                        relative={true}
                        onClick={() => handleOnClick(width)}
                        text={width}
                        selected={variantWidth}
                    />
                ))}
            </div>
        </div>
    )
}
export default withTranslation()(WidthSelector);
